import {createI18n} from 'vue-i18n';

const translations = window.translations ?? {};

const i18n = createI18n({
    locale: window.locale,
    fallbackLocale: 'de',
    messages: translations,
    legacy: false,
});

export default i18n;
